import { request } from "../utils/request";

// Authenticated-user (account) endpoints. The shared `request` instance
// attaches the bearer token, so these only work while signed in.
export default {
    // GET /user/profile → returns the user object directly as the JSON body.
    getProfile: () => request.get("/user/profile"),

    // PUT /user/profile → updates username, phone, bio and social links.
    updateProfile: (payload) => request.put("/user/profile", payload),

    // PUT /user/password → current_password + password + password_confirmation.
    changePassword: (payload) => request.put("/user/password", payload),

    // POST /user/profile-image (multipart) → { image: <url> }.
    uploadProfileImage: (formData) =>
        request.post("/user/profile-image", formData, {
            headers: { "Content-Type": "multipart/form-data" },
        }),

    deleteProfileImage: () => request.delete("/user/profile-image"),
};
